import { FC, useCallback } from 'react';

import SelectBase, { SelectBaseProps } from 'components/SelectBase';

import { SelectChangeEvent } from '@mui/material/Select';
import { useFilter } from 'lib';

type Props = Omit<SelectBaseProps, 'options'>;

type Option = {
  value?: '0' | '1' | '';
  label: string;
};

const options: Option[] = [
  {
    value: '',
    label: 'Rodyti visus',
  },
  {
    value: '1',
    label: 'Atnaujinta sėkmingai',
  },
  {
    value: '0',
    label: 'Nepavyko atnaujinti',
  },
];

const FlightUpdateStatusFilter: FC<Props> = props => {
  const [value, setValue] = useFilter('isUpdating');

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      setValue(event.target.value);
    },
    [setValue]
  );

  return (
    <SelectBase
      autoWidth
      options={options}
      value={value ?? ''}
      onChange={handleChange}
      placeholder="Atnaujinimo būklė"
      label="Atnaujinimo būklė"
      {...props}
    />
  );
};

export default FlightUpdateStatusFilter;
